import { environnement } from "configs/environnement";
import api from "./api";
import { ISaveFund, IUpdateFund, IFundResponse } from "models/church.types";

const BASE_URL = `${environnement.baseURL}/funds`;

export const FundService = {
  /**
   * GET /api/eglise/v1/funds/_search
   * Récupère la liste paginée de toutes les caisses/fonds (sans filtre de recherche)
   */
  getAll: async (page: number, size: number) => {
    const response = await api.get<IFundResponse[]>(`${BASE_URL}/_search`, {
      params: {
        page: page,
        size: size,
        sort: "id,desc",
        query: "", // Requête vide pour ramener l'ensemble des caisses
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },

  /**
   * POST /api/eglise/v1/funds
   * Création d'une nouvelle caisse / d'un fonds
   */
  create: async (fund: ISaveFund): Promise<IFundResponse> => {
    const response = await api.post<IFundResponse>(`${BASE_URL}`, fund);
    return response.data;
  },

  /**
   * PUT /api/eglise/v1/funds
   * Mise à jour d'un fonds existant
   */
  update: async (fund: IUpdateFund): Promise<IFundResponse> => {
    const response = await api.put<IFundResponse>(`${BASE_URL}`, fund);
    return response.data;
  },

  /**
   * GET /api/eglise/v1/funds/{id}
   * Récupération d'un fonds par son identifiant unique
   */
  getById: async (id: number): Promise<IFundResponse> => {
    const response = await api.get<IFundResponse>(`${BASE_URL}/${id}`);
    return response.data;
  },

  /**
   * DELETE /api/eglise/v1/funds/{id}
   * Suppression d'une caisse
   */
  delete: async (id: number): Promise<void> => {
    await api.delete(`${BASE_URL}/${id}`);
  },

  /**
   * GET /api/eglise/v1/funds/_search
   * Recherche textuelle d'un fonds avec pagination
   */
  search: async (query: string, page: number, size: number) => {
    const response = await api.get<IFundResponse[]>(`${BASE_URL}/_search`, {
      params: {
        query: query,
        page: page,
        size: size,
        sort: "id,desc",
      },
    });
    return {
      data: response.data,
      totalCount: parseInt(response.headers["x-total-count"] || "0"),
    };
  },
};
